<template>
  <component
    :is="href ? 'a' : 'button'"
    :type="type"
    :href="href"
    :class="{
      button: true,
      disabled,
      small,
    }"
  >
    <span class="button-title"><slot /></span>
  </component>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    type: {
      default: 'button',
      validator(value) {
        return ['button', 'submit'].indexOf(value) !== -1;
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped src="./baseButton.css"></style>
